import { render, staticRenderFns } from "./MaxStudyDurationCard.vue?vue&type=template&id=ccf6e85a&scoped=true"
import script from "./MaxStudyDurationCard.vue?vue&type=script&lang=ts"
export * from "./MaxStudyDurationCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxStudyDurationCard.vue?vue&type=style&index=0&id=ccf6e85a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf6e85a",
  null
  
)

export default component.exports